<div class="table-surface">
  <div class="table-surface__toolbar">
    <app-table-toolbar
      [title]="title"
      [titleIcon]="titleIcon"
      [titleAriaLabel]="titleAriaLabel"
      [titleInfoTooltip]="titleInfoTooltip"
      [columns]="columns"
      [activeFilters]="activeFilters"
      [density]="density"
      [tableId]="tableId"
      [enableSearch]="enableSearch"
      [searchPlaceholder]="searchPlaceholder"
      [isLoading]="isLoading"
      [enableColumnVisibility]="enableColumnVisibility"
      [enableDensity]="enableDensity"
      [enableExport]="enableExport"
      [enableFilter]="enableFilter"
      [enableClearFilters]="enableClearFilters"
      [enableSort]="enableSort"
      [sortState]="sortState"
      [sortHiddenColumnKeys]="sortHiddenColumnKeys"
      [filterMenuTitle]="filterMenuTitle"
      [filterOptions]="filterOptions"
      [filterGroups]="filterGroups"
      [primaryActionLabel]="resolvedPrimaryActionLabel"
      [primaryActionMobileLabel]="resolvedPrimaryActionMobileLabel"
      [primaryActionOptions]="primaryActionOptions"
      [viewOptions]="resolvedViewOptions"
      [activeView]="activeView"
      [readonly]="readOnly"
      (searchChange)="searchChange.emit($event)"
      (searchInput)="searchInput.emit($event)"
      (filterRemove)="filterRemove.emit($event)"
      (filterOptionSelect)="filterOptionSelect.emit($event)"
      (clearFiltersClick)="clearFiltersClick.emit()"
      (sortChange)="onToolbarSortChange($event)"
      (columnVisibilityChange)="onToolbarColumnVisibility($event)"
      (densityChange)="onToolbarDensityChange($event)"
      (exportClick)="onExport()"
      (primaryActionClick)="primaryActionClick.emit()"
      (primaryActionOptionClick)="primaryActionOptionClick.emit($event)"
      (viewChange)="viewChange.emit($event)">
      <ng-container toolbarActions>
        <ng-content select="[toolbarActions]"></ng-content>
      </ng-container>
      <ng-container toolbarTitleActions>
        <ng-content select="[toolbarTitleActions]"></ng-content>
      </ng-container>
      <div *ngIf="hasQuickFilters" quickFilterPanel class="table-surface__quick-filter-panel">
        <ng-content select="[quickFilterPanel]"></ng-content>
      </div>
      <div filterPanel class="table-surface__filter-panel">
        <ng-content select="[filterPanel]"></ng-content>
      </div>
    </app-table-toolbar>
  </div>

  <ng-container *ngIf="shouldShowTable">
    <div class="table-surface__desktop-table">
      <app-data-table
        [tableId]="tableId"
        [columns]="columns"
        [data]="data"
        [isLoading]="isLoading"
        [errorMessage]="errorMessage"
        [noDataMessage]="noDataMessage"
        [paginationConfig]="paginationConfig"
        [pageSizeOptions]="pageSizeOptions"
        [showPageSizeSelector]="showPageSizeSelector"
        [tableHeight]="tableHeight"
        [enableRowHover]="enableRowHover"
        [enableDragDrop]="enableDragDrop"
        [cellTemplate]="cellTemplate"
        [rowDetailTemplate]="rowDetailTemplate"
        [expandedRow]="expandedRow"
        [headerTemplate]="headerTemplate"
        [initialSort]="sortState || initialSort"
        [enableHeaderSort]="enableHeaderSort"
        [serverSideSort]="serverSideSort"
        [density]="density"
        [multiSort]="multiSort"
        [editableColumns]="editableColumns"
        [savingCell]="savingCell"
        (pageChange)="pageChange.emit($event)"
        (pageSizeChange)="pageSizeChange.emit($event)"
        (sortChange)="onDataTableSortChange($event)"
        (sortStateChange)="sortStateChange.emit($event)"
        (rowClick)="rowClick.emit($event)"
        (rowReorder)="rowReorder.emit($event)"
        (cellEditSave)="cellEditSave.emit($event)">
      </app-data-table>
    </div>

    <app-table-mobile-card-list
      [cardTemplate]="mobileCardTemplate"
      [columns]="mobileColumns"
      [data]="data"
      [cellTemplate]="cellTemplate"
      [rowDetailTemplate]="rowDetailTemplate"
      [expandedRow]="expandedRow"
      [isLoading]="isLoading"
      [errorMessage]="errorMessage"
      [noDataMessage]="noDataMessage"
      [paginationConfig]="paginationConfig"
      [pageSizeOptions]="pageSizeOptions"
      [showPageSizeSelector]="showPageSizeSelector"
      [enableRowHover]="enableRowHover"
      (pageChange)="pageChange.emit($event)"
      (pageSizeChange)="pageSizeChange.emit($event)"
      (rowClick)="rowClick.emit($event)">
    </app-table-mobile-card-list>
  </ng-container>

  @if (shouldShowCollection) {
    <div class="table-surface__collection" [class.table-surface__collection--board]="activeView === 'board'" [style.height]="tableHeight" [attr.aria-busy]="isLoading">
      @if (isLoading) { <mat-progress-bar mode="indeterminate" aria-label="Cargando datos" /> }
      @if (isLoading && !data?.length) { <app-loading-state message="Obteniendo datos..." [spinnerDiameter]="50" /> }
      @else if (!errorMessage && !data?.length) { <app-empty-state icon="inbox" [title]="noDataMessage" description="No hay registros que mostrar en este momento" /> }
      @else if (!errorMessage) {
        @if (activeView === 'list') {
          <app-data-list [data]="data" [columns]="columns" [cellTemplate]="cellTemplate" [itemTemplate]="listItemTemplate" (rowClick)="rowClick.emit($event)" />
        } @else {
          <app-data-board [data]="data" [columns]="columns" [cellTemplate]="cellTemplate" [cardTemplate]="boardCardTemplate" [groups]="boardGroups" [groupBy]="boardGroupBy" [enableDragDrop]="enableBoardDragDrop" (rowClick)="rowClick.emit($event)" (groupChange)="boardGroupChange.emit($event)" />
        }
      }
    </div>
    @if (!errorMessage && paginationConfig) {
      <app-data-pagination [paginationConfig]="paginationConfig" [isLoading]="isLoading" [showPageSizeSelector]="showPageSizeSelector" [pageSizeOptions]="pageSizeOptions" (pageChange)="pageChange.emit($event)" (pageSizeChange)="pageSizeChange.emit($event)" />
    }
  }

  <ng-container *ngIf="shouldShowCustomView">
    <ng-container *ngTemplateOutlet="customViewTemplate; context: { $implicit: data, data: data }"></ng-container>
  </ng-container>
</div>
